export const DEFAULT_DESKTOP_SITE_WIDTH = 980

export const MOBILE_SITE_WIDTH = 320

export const EMPTY_OBJECT: Record<string, any> = {}
export const EMPTY_ARRAY: Array<string> = []
